import { Button, Card, Col, Image, Row, Typography } from "antd";
import { useContext, useEffect, useState } from "react";
// import wam from "../assets/audio/wam.mp3";
// import wam2 from "../assets/audio/wam2.mp3";
// import wam3 from "../assets/audio/wam3.mp3";
// import wam4 from "../assets/audio/wam4.mp3";
import { format } from "date-fns";
import {
  CalendarOutlined,
  ClockCircleOutlined,
  PlayCircleOutlined,
} from "@ant-design/icons";
import Motion from "../components/motion";
import { darkTheme, lightTheme, UserContext } from "../App";
//import Swal from "sweetalert2";
import Loader from "../components/Loader";
import ShinyText from "../components/ShinyText";
import EpisodeModal from "../components/EpisodeModal";
//import { useMedia } from "../components/MediaContext";
import useFetchEpisodes from "../hooks/fetchEpisodes";

const { Title, Text, Paragraph } = Typography;

// const initialEpisodes = [
//   {
//     id: 1,
//     title: "How do I create this?",
//     description:
//       "I sit down with a behavioral scientist to unpack sustainable habit loops and work-life design.",
//     timestamp: "2025-07-08",
//     episode: 1,
//     audio: wam,
//     cover:
//       "https://plus.unsplash.com/premium_photo-1668790459187-3b2a743253e1?w=900",
//   },
//   {
//     id: 2,
//     title: "How do I create this again?",
//     description:
//       "I sit down with a behavioral scientist to unpack sustainable habit loops and work-life design.",
//     timestamp: "2025-07-08",
//     episode: 2,
//     audio: wam2,
//     cover: "https://images.unsplash.com/photo-1590410790503-ff66c3e9e1e5?w=900",
//   },
//   {
//     id: 3,
//     title: "How do I create this once more?",
//     description:
//       "I sit down with a behavioral scientist to unpack sustainable habit loops and work-life design.",
//     timestamp: "2025-07-08",
//     episode: 3,
//     audio: wam3,
//     cover:
//       "https://plus.unsplash.com/premium_photo-1664526283895-54f9de9e0d96?w=900",
//   },
//   {
//     id: 4,
//     title: "How do I create this: Part 1?",
//     description:
//       "I sit down with a behavioral scientist to unpack sustainable habit loops and work-life design.",
//     timestamp: "2025-07-08",
//     episode: 4,
//     audio: wam4,
//     cover: "https://images.unsplash.com/photo-1517384084767-6bc118943770?w=900",
//   },
//   {
//     id: 5,
//     title: "How do I create this: Part 2?",
//     description:
//       "I sit down with a behavioral scientist to unpack sustainable habit loops and work-life design.",
//     timestamp: "2025-07-18",
//     episode: 5,
//     audio: wam4,
//     cover: "https://images.unsplash.com/photo-1517384084767-6bc118943770?w=900",
//   },
// ];

export const formatDuration = (input) => {
  let seconds = Number(input);

  // Normalize input
  if (seconds > 1e12) {
    // > ~31 years in µs, treat as µs
    seconds = Math.floor(seconds / 1e6);
  } else if (seconds > 1e6) {
    // > ~11 days in ms, treat as ms
    seconds = Math.floor(seconds / 1000);
  } else if (seconds > 1000) {
    // > 16 minutes in seconds, likely ms
    seconds = Math.floor(seconds / 1000);
  } else {
    // Already in seconds
    seconds = Math.floor(seconds);
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  return [hours, minutes, secs]
    .map((v) => String(v).padStart(2, "0"))
    .join(":");
};

function Episodes() {
  useEffect(() => {
    document.title = "Episodes - A Deeper Dive";
  }, []);

  const {
    darkMode,
    // playMedia,
    //  currentEp,
    //   setCurrentEp,
    isMobile,
  } = useContext(UserContext);
  const { episodes, episodesLoading } = useFetchEpisodes();
  // const {
  //    isPlaying,
  //     setIsPlaying,
  //    playlist,
  //   setPlaylist,
  // } = useMedia();
  //const [episodeItems, setEpisodes] = useState(initialEpisodes);
  const [openEpisodeModal, setOpenEpisodeModal] = useState(false);
  //eslint-disable-next-line no-unused-vars
  const [episodeContent, setEpisodeContent] = useState(null);
  const episodeItems = episodes?.items;
  const [ellipsisMap, setEllipsisMap] = useState({});

  useEffect(() => {
    if (episodeItems) {
      const initialMap = episodeItems?.reduce((acc, item) => {
        acc[item.id] = true;
        return acc;
      }, {});
      setEllipsisMap(initialMap);
    }
  }, [episodeItems]);

  const toggleEllipsis = (key) => {
    setEllipsisMap((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // const viewModal = (episode) => {
  //   setLoading(true);
  //   setOpenEpisodeModal(true);
  //   setEpisodeContent(episode);
  //   setTimeout(() => setLoading(false), 100);
  // };

  //const allEpisodes = [...oldEpisodes];

  // const addToPlaylist = (episode) => {
  //   const selectedEpisode = allEpisodes.find((e) => e.id === episode.id);
  //   if (!selectedEpisode) {
  //     console.warn("Episode not found");
  //     return;
  //   }
  //   setPlaylist((prevList) => {
  //     const updatedList = [
  //       ...prevList,
  //       {
  //         id: selectedEpisode.id,
  //         title: selectedEpisode.title,
  //         description: selectedEpisode.description,
  //         timestamp: selectedEpisode.timestamp,
  //         episode: selectedEpisode.episode,
  //         audio: selectedEpisode.audio,
  //         cover: selectedEpisode.cover,
  //       },
  //     ];
  //     localStorage.setItem("playlist", JSON.stringify(updatedList));
  //     return updatedList;
  //   });
  // };

  // Load durations dynamically

  // useEffect(() => {
  //   initialEpisodes.forEach((ep, idx) => {
  //     const audio = new Audio(ep.audio);
  //     audio.onloadedmetadata = () => {
  //       setEpisodes((prev) =>
  //         prev.map((e) =>
  //           e.id === ep.id ? { ...e, duration: Math.round(audio.duration) } : e
  //         )
  //       );
  //     };
  //   });
  // }, []);

  if (episodesLoading) return <Loader text={"Please wait..."} size={"large"} />;

  return (
    <>
      <Motion>
        <div>
          <div style={{ textAlign: "center" }}>
            <ShinyText
              text={"Start Listening Today"}
              disabled={false}
              speed={3}
              className="custom-class"
            />
            <Title
              style={{
                color: darkMode ? darkTheme.color : lightTheme.color,
                marginTop: 0,
                fontFamily: "Raleway",
              }}
            >
              Latest Episodes
            </Title>
          </div>

          <div style={{ margin: 10, padding: "30px 40px" }}>
            <Row gutter={[16, 16]}>
              {episodeItems?.map((ep) => (
                <Col key={ep.id} xs={24} sm={12} md={8}>
                  <Card
                    hoverable
                    style={{
                      minHeight: 220,
                      borderRadius: 12,
                      display: "flex",
                      flexDirection: "column",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                      background: darkMode
                        ? darkTheme.backgroundColor
                        : lightTheme.backgroundColor,
                      border: `1px solid ${darkMode ? "#fff" : "#333"}`,
                    }}
                    cover={
                      <div
                        style={{
                          position: "relative",
                          width: "100%",
                          height: 220,
                          overflow: "hidden",
                          borderTopLeftRadius: 12,
                          borderTopRightRadius: 12,
                          padding: 1,
                        }}
                      >
                        {/* <div
                          style={{
                            position: "absolute",
                            top: "10%",
                            right: "-3%",
                            transform: "translate(-50%, -50%)",
                            color: "#fff",
                            zIndex: 2,
                          }}
                        >
                          <Popover
                            title={`${
                              playlist.some((e) => e.id === ep.id)
                                ? "Added to playlist"
                                : "Add to playlist"
                            }`}
                            trigger="hover"
                          >
                            <Button
                              shape="circle"
                              style={{
                                fontSize: 16,
                                fontFamily: "Roboto",
                                color: "#333",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.45)",
                              }}
                              onClick={() => {
                                addToPlaylist(ep);
                              }}
                              disabled={
                                playlist.some((e) => e.id === ep.id)
                                  ? true
                                  : false
                              }
                            >
                              {playlist.some((e) => e.id === ep.id) ? (
                                <CheckOutlined style={{ color: "green" }} />
                              ) : (
                                <UnorderedListOutlined />
                              )}
                            </Button>
                          </Popover>
                        </div> */}
                        <Image
                          src={ep.images[0].url}
                          alt="pod_cover"
                          preview={false}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: 12,
                          }}
                          className="ant2"
                        />

                        {/* Play Button Overlay */}
                        {/* <Button
                          shape="circle"
                          icon={
                            currentEp?.id === ep.id && isPlaying ? (
                              <PauseCircleOutlined style={{ fontSize: 28 }} />
                            ) : (
                              <PlayCircleOutlined style={{ fontSize: 28 }} />
                            )
                          }
                          size="large"
                          // onClick={() => {
                          //   if (currentEp?.id === ep.id && isPlaying) {
                          //     setIsPlaying(false);
                          //   } else {
                          //     setLoading(true);
                          //     try {
                          //       setCurrentEp(ep);
                          //       playMedia(ep);
                          //       setIsPlaying(true);
                          //       addToPlaylist(ep);
                          //     } catch (error) {
                          //       console.log(error);
                          //       Swal.fire({
                          //         icon: "error",
                          //         title: "Error",
                          //         text: "Something went wrong. Refresh the page and try again",
                          //       });
                          //     } finally {
                          //       setLoading(false);
                          //     }
                          //   }
                          // }}
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            backgroundColor: "#f70535",
                            color: "#fff",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                            zIndex: 2,
                          }}
                        /> */}

                        <Button
                          shape="circle"
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            backgroundColor: "#484789",
                            color: "#fff",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
                            zIndex: 2,
                          }}
                        >
                          <a
                            href={ep.external_urls.spotify}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <PlayCircleOutlined style={{ fontSize: 28 }} />
                          </a>
                        </Button>
                      </div>
                    }
                  >
                    {/* Meta info */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: 2,
                      }}
                    >
                      <Text
                        type="secondary"
                        style={{
                          fontSize: 14,
                          fontFamily: "Roboto",
                          color: darkMode ? darkTheme.color : lightTheme.color,
                        }}
                      >
                        <CalendarOutlined />{" "}
                        {format(new Date(ep.release_date), "PPP")}
                      </Text>
                      <Text
                        type="secondary"
                        style={{
                          fontSize: 14,
                          fontFamily: "Roboto",
                          color: darkMode ? darkTheme.color : lightTheme.color,
                        }}
                      >
                        <ClockCircleOutlined />{" "}
                        {ep.duration_ms
                          ? `${formatDuration(ep.duration_ms)}`
                          : "…"}
                      </Text>
                    </div>

                    {/* Title + description */}
                    <Card.Meta
                      title={
                        <Title
                          level={isMobile ? 5 : 4}
                          style={{
                            marginTop: 1,
                            marginBottom: 2,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontFamily: "Raleway",
                            color: darkMode
                              ? darkTheme.color
                              : lightTheme.color,
                          }}
                        >
                          {ep.name}
                        </Title>
                      }
                      description={
                        <Paragraph
                          type="secondary"
                          style={{
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            fontFamily: "Raleway",
                            color: darkMode
                              ? darkTheme.color
                              : lightTheme.color,
                            marginBottom: 0,
                          }}
                          ellipsis={ellipsisMap[ep.id] ? { rows: 2 } : false}
                        >
                          {ep.description}
                        </Paragraph>
                      }
                    />
                    <div
                      style={{
                        marginTop: 0,
                        textAlign: "right",
                      }}
                    >
                      <Button
                        type="text"
                        style={{
                          fontFamily: "Raleway",
                          color: darkMode ? darkTheme.color : lightTheme.color,
                        }}
                        onClick={() => toggleEllipsis(ep.id)}
                        // onClick={() => {
                        //   viewModal(ep);
                        // }}
                      >
                        {ellipsisMap[ep.id] ? "More" : "Less"}
                      </Button>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      </Motion>
      {/* <MediaPlayer media={mediaPlaying} /> */}

      <EpisodeModal
        openModal={openEpisodeModal}
        setOpenModal={setOpenEpisodeModal}
        loading={episodesLoading}
        episodeContent={episodeContent}
      />
    </>
  );
}

export default Episodes;
